var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-float-card",style:(_vm.cardStyle),on:{"click":_vm.handledClick}},[_c('div',{staticClass:"float-bg"})])}
var staticRenderFns = []

export { render, staticRenderFns }